module.exports = __webpack_public_path__ + "img/index01.04cdc67f.png";